import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import OrderForm from './components/OrderForm';

export default function Order() {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  useEffect(() => {
    // Load items from localStorage
    const savedItems = localStorage.getItem('selectedOrderItems');
    if (savedItems) {
      try {
        const items = JSON.parse(savedItems);
        setSelectedItems(items);
      } catch {
        setSelectedItems([]);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">
                Place Your <span className="text-yellow-600">Order</span>
              </h1>
              <p className="text-xl text-gray-600">
                Complete the form below to place your order
              </p>
            </div>
            <OrderForm preSelectedItems={selectedItems} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}